'use strict';

const React = require('react');
const Picture = require('../elements/Picture');
const TeaserLink = require('./TeaserLink.jsx');
const BroadcastInfo = require('./BroadcastInfo.jsx');
const TeaserDestination = require('./TeaserDestination.jsx');
const classNames = require('classnames');

const Teaser = (props) => {
	if (!props || !props.model || Object.keys(props.model).length === 0) { return (<noscript/>); }

	const model = props.model;
	const imageType = props.imageType || 'large';
	const teaserArea = props.teaserArea || 'standard';
	const teaserLayout = props.layout;
	
	/* For screen readers, we only show the most relevant information in teaser */
	const ariaText = model.description + ", " + model.title;

	const figureClass = classNames({
		"svtse_teaser__figure": true,
		"svtse_teaser__figure--type1": teaserLayout === "type1"
	});

	const textblockClass = classNames({
		"svtse_teaser__text-block": true,
		"svtse_teaser__text-block--type1": teaserLayout === "type1",
		"svtse_teaser__text-block--type1 svtse_teaser__text-block--hero": teaserArea === "hero"
	});

	const positionRelClass = classNames({
		"svtse_teaser__position-rel": teaserLayout === "type1",
		"svtse_teaser__position-rel--hero": teaserArea === "hero"
	});

	const headlineClass = classNames({
		"svtse_teaser-headline": true,
		"svtse_teaser-headline--hero": teaserArea === "hero"
	});
	
	const headlineDescriptionClass = classNames({
		"svtse_teaser-headline__description": true,
		"svtse_teaser-headline__description--hero": teaserArea === "hero"
	});
	
	/* Teaser that have a direct link to Play or Öppet arkiv */
	if (model.destination && model.targetUrl) {
		return (
			<TeaserDestination model={model} teaserArea={teaserArea} imageType={imageType}/>
		);
	}

	/* Standard teaser */
	return (
		<TeaserLink model={model} className="svtse_teaser" aria-label={ariaText}>
			<article>
				<Picture model={model.cover} type={imageType} className={figureClass} imageClass="svtse_teaser__img" />

				<div className={positionRelClass}>
					<div className={textblockClass}>
						<h2 className={headlineClass}>
							<span className={headlineDescriptionClass}>{model.description} </span>
							<span className="svtse_teaser-headline__title">{model.title}</span>
						</h2>
						<p className="svtse_teaser-bread">
							{model.text} <BroadcastInfo className="svtse_teaser-bread__broadcast-info" teaser={model} />
						</p>
					</div>
				</div>
			</article>
		</TeaserLink>
	);
};

module.exports = Teaser;




/** WEBPACK FOOTER **
 ** ./app/components/Teaser/Teaser.js
 **/